export type EcoNodeKey = 'you' | 'events' | 'brands' | 'creators';

export const ecosystemNodes: Array<{
  key: EcoNodeKey;
  label: string;
  tagline: string;
  link: string;
  detail: string;
}> = [
  {
    key: 'you',
    label: 'You',
    tagline: 'Discover · Play · Be rewarded',
    link: 'Interaction',
    detail:
      'Find relevant events, take part voluntarily, get transparent rewards and keep full control over your data.',
  },
  {
    key: 'events',
    label: 'Events',
    tagline: 'Activate · Engage · Grow',
    link: 'Participants',
    detail:
      'Events that already exist, from consumer fairs to festivals. AVEGA adds to them. It doesn’t organize them or sell tickets.',
  },
  {
    key: 'brands',
    label: 'Brands',
    tagline: 'Reach · Convert · Measure',
    link: 'Campaigns',
    detail: 'Sponsors provide the prizes and ask the questions. They see group results, never your personal profile.',
  },
  {
    key: 'creators',
    label: 'Creators',
    tagline: 'Inspire · Share · Earn',
    link: 'Content',
    detail: 'Creators share personal links to the app and selected events, so you discover them through people you follow.',
  },
];
